import React from 'react';
import ManageAccount from './components/ManageAccount.js';
import connect from './connect';
import './assets/ManageAccount.css';
import { Elements } from 'react-stripe-elements'; 

const Component = connect(ManageAccount);

const ComponentWithElements = () => (
  <Elements>
    <Component />
  </Elements>
);

export default ComponentWithElements;



// WEBPACK FOOTER //
// ./src/routes/ManageAccount/index.js